import React from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Discount from "./discount";
import DiscountSection from "./discountSection";
import {sortByOrder} from "../../utilities";
import {DISCOUNT_SECTION_TYPES} from "./discountsInterface";

const SortableItem = SortableElement(({ discount, discountSection, discountIndex, sectionIndex }) => {
  return <Discount discount={discount} discountSection={discountSection} discountIndex={discountIndex} sectionIndex={sectionIndex}/>
});

const SortableList = SortableContainer(({ discountSections }) => {
  const sections = sortByOrder(discountSections.filter(section => section.type !== DISCOUNT_SECTION_TYPES.finance));
  return (
    <ul className="discounts-body__sections">
      {sections.map((discountSection, discountSectionIndex) => {
        const discounts = sortByOrder(discountSection.discounts);
        return (
          <DiscountSection discountSection={discountSection} key={discountSectionIndex}>
            {discounts.map((discount, discountIndex) => {
              if (discount.nestedParent) {
                return null
              }
              return <SortableItem key={discountIndex}
                                   index={discountIndex}
                                   discountIndex={discountIndex}
                                   collection={discountSectionIndex}
                                   sectionIndex={discountSection.order}
                                   discountSection={discountSection}
                                   discount={discount} />
            })}
          </DiscountSection>
        )
      })}
    </ul>
  );
});

export default ({ onSortEnd, onSortStart, shouldCancelStart, discountSections }) => {
  return <SortableList discountSections={discountSections}
                       helperClass='sortableHelper'
                       axis={"y"}
                       // pressDelay={100}
                       shouldCancelStart={shouldCancelStart}
                       onSortStart={onSortStart}
                       onSortEnd={onSortEnd} />
}
